import type { FireflyRuntime, ModuleRegisterFunction } from "@squide/firefly";

export const registerIntentBox: ModuleRegisterFunction<FireflyRuntime> = async runtime => {
    if (runtime.isMswEnabled) {
        const { intentBoxRequestHandlers } = await import("./mocks/intentBoxRequestHandlers.ts");

        runtime.registerRequestHandlers(intentBoxRequestHandlers);
    }
};
